module.exports = __webpack_public_path__ + "img/meituan.6c81f7cd.png";